var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.rptStage === 1)?_c('div',[_c('QueryConditions')],1):_vm._e(),(_vm.rptStage === 2)?_c('div',[_c('QueryColumns')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }